import { render } from "./prescriptionHospitalScanPayment.vue?vue&type=template&id=330c35bd&scoped=true"
import script from "./prescriptionHospitalScanPayment.vue?vue&type=script&lang=js"
export * from "./prescriptionHospitalScanPayment.vue?vue&type=script&lang=js"

import "./prescriptionHospitalScanPayment.vue?vue&type=style&index=0&id=330c35bd&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330c35bd"]])

export default __exports__